import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// The design system's type scale and control sizes are custom theme values: plain tailwind-merge reads `text-title1`
// as a text colour and drops the size when merged with a colour class.
export const DS_FONT_SIZES = ['display', 'title1', 'title2', 'title3', 'body', 'body-strong', 'small', 'small-strong', 'caption', 'overline', 'label', 'numeric', 'numeric-large'] as const

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...DS_FONT_SIZES] }],
      shadow: [{ shadow: ['glow-brand'] }],
    },
  },
})

/** The Go backend sends an empty list as `null` (nil slice); normalise list fields where a response enters the app. */
export function listOrEmpty<T>(list: T[] | null | undefined): T[] {
  return Array.isArray(list) ? list : []
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Resolves an S3 media key (or an already absolute URL) to something an <img> can load. */
export function mediaUrl(keyOrUrl: string | undefined, host: string): string | undefined {
  if (!keyOrUrl) return undefined
  if (/^https?:\/\//.test(keyOrUrl)) return keyOrUrl
  return host ? `${host}/${keyOrUrl.replace(/^\/+/, '')}` : keyOrUrl
}
